import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.2728 11L19.5455 16H23.091C23.091 20.1375 19.9118 23.5 16 23.5C14.8064 23.5 13.6718 23.1875 12.6909 22.625L10.9655 24.45C12.4191 25.425 14.1446 26 16 26C21.2237 26 25.4546 21.525 25.4546 16H29.0001L24.2728 11ZM8.90917 16C8.90917 11.8625 12.0883 8.5 16.0001 8.5C17.1937 8.5 18.3283 8.8125 19.3092 9.375L21.0347 7.55C19.581 6.575 17.8556 6 16.0001 6C10.7765 6 6.54553 10.475 6.54553 16H3.00006L7.72735 21L12.4546 16H8.90917Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
